module.exports = __webpack_public_path__ + "static/media/layout.b6456a37.svg";